import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=fc6baf02&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=fc6baf02&prod&scoped=true&lang=css&external"
import style1 from "./Invoices.vue?vue&type=style&index=1&id=fc6baf02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6baf02",
  null
  
)

export default component.exports